"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var StyledTitle = (0, _theming.styled)("h3", process.env.NODE_ENV === "production" ? {
  target: "ekn4x6m0"
} : {
  target: "ekn4x6m0",
  label: "StyledTitle"
})("font-weight:", _styles.typography.weight.black, ";font-size:", _styles.typography.size.m2, "px;line-height:", _styles.typography.size.m3, "px;color:", _styles.color.darkest, ";");

var Title = function Title(props) {
  return /*#__PURE__*/_react["default"].createElement(StyledTitle, props);
};

exports.Title = Title;